import React from 'react';
import { Link } from 'react-router-dom';

import paths from 'routes/paths';
import { TIME_OPTION } from 'constants/time';

export const PUT_AWAY_LIST_COLUMNS = [
  {
    accessorKey: 'id',
    header: 'Putaway ID',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { id, completed_at } = original;

      const isCompleted = !!completed_at;
      const url = `${paths.putAwayDetails(id)}?completed=${isCompleted}`;

      return (
        <Link to={url}>
          <strong>{id}</strong>
        </Link>
      );
    },
  },
  {
    accessorKey: 'created_by',
    header: 'Created By',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { created_by } = original;

      return <span>{created_by?.email || '-'}</span>;
    },
  },
  {
    accessorKey: 'total_quantity',
    header: 'Total Quantity',
    enableSorting: false,
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { total_quantity } = original;

      return <span>{total_quantity || 0}</span>;
    },
  },
  {
    accessorKey: 'grn_quantity',
    header: 'GRN Quantity',
    enableSorting: false,
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { grn_quantity } = original;

      return <span>{grn_quantity}</span>;
    },
  },
  {
    accessorKey: 'created',
    header: 'Created',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { created } = original;

      return (
        <span>{new Date(created).toLocaleString('en-IN', TIME_OPTION)}</span>
      );
    },
  },
  {
    accessorKey: 'completed_by',
    header: 'Completed By',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { completed_by } = original;

      return <span>{completed_by?.email || '-'}</span>;
    },
  },
];

export const CREATE_PUT_AWAY_LIST_COLUMNS = [
  {
    accessorKey: 'created',
    header: 'Created',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { created } = original;

      return (
        <span>{new Date(created).toLocaleString('en-IN', TIME_OPTION)}</span>
      );
    },
  },
  {
    accessorKey: 'id',
    header: 'GRN ID',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { id } = original;

      return (
        <Link to={paths.grnDetails(id)}>
          <strong>{id}</strong>
        </Link>
      );
    },
  },
  {
    accessorKey: 'total_amount',
    header: 'Total Amount',
    enableSorting: false,
    meta: {
      valueType: 'number',
    },
    cell: ({ row: { original } }) => {
      const { total_amount } = original;

      return <span>{total_amount || 0}</span>;
    },
  },
  {
    accessorKey: 'approved_at',
    header: 'Approved',
    enableSorting: true,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { approved_at } = original;

      return (
        <span>
          {new Date(approved_at).toLocaleString('en-IN', TIME_OPTION)}
        </span>
      );
    },
  },
  {
    accessorKey: 'approved_by',
    header: 'Approved By',
    enableSorting: false,
    meta: {
      valueType: 'string',
    },
    cell: ({ row: { original } }) => {
      const { approved_by } = original;

      return <span>{approved_by?.email || '-'}</span>;
    },
  },
];
